import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./Users'));

function LoadableUsers() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableUsers;
